import { Icon } from "../components/Icon";
import { Sheet } from "../components/Sheet";
import { config } from "../config";
import { t } from "../i18n";
import { SLEEP_MINUTES, type SleepSetting } from "../lib/sleepTimer";
import type { SleepOption } from "./PlayerContext";

interface Choice {
  id: string;
  label: string;
  option: SleepOption;
  selected: (sleep: SleepSetting) => boolean;
}

/**
 * Выбор таймера сна. «1 min (test)» — только в мок-режиме: иначе проверить затухание
 * можно лишь за пятнадцать минут ожидания.
 */
export function SleepSheet({ sleep, onChoose, onClose }: { sleep: SleepSetting; onChoose: (option: SleepOption) => void; onClose: () => void }) {
  const choices: Choice[] = [
    { id: "off", label: t("sleep.off"), option: { mode: "off" }, selected: (s) => s.mode === "off" },
    ...SLEEP_MINUTES.map(
      (minutes): Choice => ({
        id: `m${minutes}`,
        label: t("sleep.minutes", { min: minutes }),
        option: { mode: "minutes", minutes },
        selected: (s) => s.mode === "timer" && s.minutes === minutes,
      }),
    ),
    {
      id: "episode",
      label: t("sleep.endOfEpisode"),
      option: { mode: "episode_end" },
      selected: (s) => s.mode === "episode_end",
    },
  ];
  if (config.mock) {
    choices.push({
      id: "test",
      label: t("sleep.test"),
      option: { mode: "minutes", minutes: 1 },
      selected: (s) => s.mode === "timer" && s.minutes === 1,
    });
  }

  return (
    <Sheet title={t("sleep.title")} onClose={onClose}>
      <ul className="choices">
        {choices.map((choice) => {
          const selected = choice.selected(sleep);
          return (
            <li key={choice.id}>
              <button
                type="button"
                className={`choice${selected ? " choice--selected" : ""}`}
                aria-pressed={selected}
                onClick={() => {
                  onChoose(choice.option);
                  onClose();
                }}
              >
                <span>{choice.label}</span>
                {selected && <Icon name="check" size={20} />}
              </button>
            </li>
          );
        })}
      </ul>
      <p className="hint">{t("sleep.fadeNote")}</p>
    </Sheet>
  );
}
